import React, { useState, useEffect, useMemo, useContext } from 'react';
import SubscriptionRow from './SubscriptionRow'
import OfficeHourRow from './OfficeHourRow'
import OfficeHourable from '../../concerns/OfficeHourable'
import { SubscriptionsContext } from '../../contexts/Subscriptions'
import { OfficeHourSubscriptionsContext } from '../../contexts/OfficeHourSubscriptions'
import { OfficeHoursContext } from '../../contexts/OfficeHours'
import { UserContext } from '../../contexts/yolk/User'
import { ErrorBoundary } from "react-error-boundary";

export default function SubscriptionsTable(props) {
  const allSubscriptions = useContext(SubscriptionsContext);
  const officeHourSubscriptions = useContext(OfficeHourSubscriptionsContext);
  const [officeHours] = useContext(OfficeHoursContext);
  const [user] = useContext(UserContext)

  const subscriptions = props.filter && allSubscriptions.filter(props.filter) || allSubscriptions
  const officeHourSubscriptionsAssigned = []

  return (<div>
      <h2 style={{display: props.titleHidden ? 'none' : 'block'}}>{props.title}</h2>
      { subscriptions.length ?
        <table className="responsive subscriptions"><tbody>
        { subscriptions.map((subscription) => {
          const subscriptionRow = (<ErrorBoundary fallback={<div>Something went wrong</div>}><SubscriptionRow id={subscription.id} key={`${subscription.id}-${subscription.quantity_index || '0'}`} /></ErrorBoundary>)
            const results = [subscriptionRow]

            const officeHourSubscriptionsRelated = OfficeHourable.officeHourSubscriptions(officeHourSubscriptions, subscription)
            const officeHourSubscription = officeHourSubscriptionsRelated.find((officeHourSubscriptionRelated) => {
              return officeHourSubscriptionRelated.isActive && officeHourSubscriptionsAssigned.indexOf(officeHourSubscriptionRelated) == -1
            })
            if (officeHourSubscription) {
              officeHourSubscriptionsAssigned.push(officeHourSubscription)
              const officeHourRow = (<OfficeHourRow id={officeHourSubscription.id} key={officeHourSubscription.id} />)
              results.push(officeHourRow)
            }

            return results
          })
        }
        </tbody>
        { props.children ?
          <tfoot><tr><td colSpan="8">{props.children}</td></tr></tfoot> : null
        }
        </table> : null
      }
  </div>)
}
